import { render, staticRenderFns } from "./bsp-reminder.vue?vue&type=template&id=44c429f0&scoped=true&"
import script from "./bsp-reminder.vue?vue&type=script&lang=js&"
export * from "./bsp-reminder.vue?vue&type=script&lang=js&"
import style0 from "./bsp-reminder.vue?vue&type=style&index=0&id=44c429f0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c429f0",
  null
  
)

export default component.exports